import Vue from 'vue'
import Router from 'vue-router'
import { getState } from './state'
import store from './store';

import desempenhoRouter from './views/tec-ped/desempenhoAcademico/desempenhoRouter';
import estudanteRouter from './views/tec-ped/estudante/estudanteRouter';
import funcionarioRoutes from './views/tec-ped/funcionario/funcionarioRoutes';
import ls from 'local-storage'

const verificandoAutorizacao = (to, from, next) => {

  const state = getState();
  let statusPago = ls.get('statusPago')
  if(to.path != '/') {
    const rotaAtual = { to: to.path, text: to.name };
    const indiceRotaAtual = state.paginas.findIndex((rota) => rota.to == rotaAtual.to && rota.text == rotaAtual.text);
    if (indiceRotaAtual === -1) {
      state.paginas.push(rotaAtual)
    } else {
      // Se o objeto existe no array, eliminar todos os objetos depois dele
      state.paginas.splice(indiceRotaAtual + 1)
    }
  } else {
    state.paginas = []
    ls.clear()
  }

  // Verifique se já estamos no processo de redirecionamento para evitar um loop infinito
  if (to.meta.isRedirecting) {
    next()
    return
  }

  const rotas = JSON.parse(ls.get('rotas'));
  if (rotas && rotas.length) {
    if(from.path !== '/estudante/minhas-solicitacoes') // Limpa os dados do objecto store
      store.state.objSolicitacao = null // Limpa os dados do objecto store



    const autorizacao = rotas.filter(objeto => objeto.url.toString().toLowerCase().trim() === to.path.toString().toLowerCase().trim())
     if (!autorizacao.length) {
      return next('/negado');
    } else {
      if((statusPago === 'N/PAGO' && autorizacao[0].showNaoPago === 1)) {
        return next('/naoPago');
      } else {
        next();
      }
    }
  } else {next();}
};


Vue.use(Router)

const TurmaComponent = () => { // configuração para os locais que ainda não têm o nestjs configurado
  return ls.get('isintegrado')
    ? import('./views/tec-ped/turma/TurmacrudLocal.vue')
    : import('./views/tec-ped/turma/TurmacrudLocal.vue');
};

const routes = [
  ...estudanteRouter,
  ...funcionarioRoutes,
  ...desempenhoRouter,

  // ====== ROTAS DO MENU PERMISSÕES ==============
  {
    path: '/permissao/menu',
    meta: { layout: 'default' },
    name: 'Menu Permissões',
    component: () => import('./views/tec-ped/permissao/menu.vue')
  },
  {
    path: '/permissao/senhas',
    meta: { layout: 'default' },
    name: 'Painel de Usuários',
    component: () => import('./views/tec-ped/permissao/senhas-painel.vue')
  },
  {
    path: '/permissao/permissoes-usuarios',
    meta: { layout: 'default' },
    name: 'Permissões dos usuários',
    component: () => import('./views/tec-ped/permissao/permissoes-sistema.vue')
  },
  // ====== FIM ROTAS DO MENU PERMISSÕES ============


  // ========= ROTAS DO MENU TURMA =================
  {
    path: '/turma/menu',
    meta: { layout: 'default' },
    name: 'menu_turma',
    component: () => import('./views/tec-ped/turma/menu.vue')
  },
  {
    path: '/painelClassTurma',
    meta: { layout: 'default' },
    name: 'painel_classe_turma',
    component: () => import('./views/tec-ped/turma/PainelClassTurma.vue')
  },
  {
    path: '/turma/listagem',
    meta: { layout: 'default' },
    name: 'listar_turmas',
    component: TurmaComponent
  },
  {
    path: '/turma/vazias',
    meta: { layout: 'default' },
    name: 'turmas_vazias',
    component: () => import('./views/tec-ped/turma/TurmasVazias.vue')
  },
  // ========= FIM TOTAS DO MENU TURMA =================


  // ======== ROTAS DO MENU ESTUDANTE ================
  {
    path: '/estudante/menu',
    meta: { layout: 'default' },
    name: 'Estudante menu',
    component: () => import('./views/tec-ped/estudante/menu.vue')
  },
  {
    path: '/estudante/transferencia-pendentes',
    meta: { layout: 'default' },
    name: 'Solicitações de transferências',
    component: () => import('./views/tec-ped/estudante/transferenciaPendentes.vue')
  },
  {
    path: '/estudante/painelclasses',
    meta: { layout: 'default' },
    name: 'painel_classe_estudante',
    component: () => import('./views/tec-ped/painelclasses.vue')
  },
  {
    path: '/estudante/listagem',
    meta: { layout: 'default' },
    name: 'estudante',
    component: () => import('./views/tec-ped/Estudante.vue')
  },
  // ======== FIM ROTAS DO MENU ESTUDANTE ================

  //=========== ROTAS NO MENU LANÇAMENTO DE NOTAS =================
  {
    path: '/lancar-nota/bloquear_lancamento',
    meta: { layout: 'default' },
    name: 'bloquear_lancamento_de_notas',
    component: () => import('./views/tec-ped/lancarNota/bloquear_desbloquearPauta.vue')
  },
  {
    path: '/lancar-nota/menu',
    meta: { layout: 'default' },
    name: 'menu_lancar_nota',
    component: () => import('./views/tec-ped/lancarNota/menu.vue')
  },
  {
    path: '/lancar-nota/primeiro_trimestre',
    meta: { layout: 'default' },
    name: 'lancar_notas_primeiro_trimestre',
    component: () => import('./views/tec-ped/lancarNota/LancarNota1T.vue')
  },
  {
    path: '/lancar-nota/segundo_trimestre',
    meta: { layout: 'default' },
    name: 'lancar_notas_segundo_trimestre',
    component: () => import('./views/tec-ped/lancarNota/LancarNota2T.vue')
  },
  {
    path: '/lancar-nota/terceiro_trimestre',
    meta: { layout: 'default' },
    name: 'lancar_nota_terceiro_trimestre',
    component: () => import('./views/tec-ped/lancarNota/LancarNota3T.vue')
  },
  {
    path: '/lancar-nota/finalista',
    meta: { layout: 'default' },
    name: 'lancar_notas_finalistas',
    component: () => import('./views/tec-ped/lancarNota/NotasFinalista.vue')
  },
  {
    path: '/lancar-nota/votada',
    meta: { layout: 'default' },
    name: 'lancar_notas_votada',
    component: () => import('./views/tec-ped/lancarNota/NotaVotada.vue')
  },
  {
    path: '/lancar-nota/caa',
    meta: { layout: 'default' },
    name: 'lancar_notas_caa',
    component: () => import('./views/tec-ped/lancarNota/NotaCaa.vue')
  },
  {
    path: '/lancar-nota/exame',
    meta: { layout: 'default' },
    name: 'larcar_notas_exame',
    component: () => import('./views/tec-ped/lancarNota/NotaExame-Admin.vue')
  },
  {
    path: '/lancar-nota/recurso',
    meta: { layout: 'default' },
    name: 'lancar_notas_recurso',
    component: () => import('./views/tec-ped/lancarNota/NotaRecurso.vue')
  },
  {
    path: '/lancar-nota/anos-anteriores',
    meta: { layout: 'default' },
    name: 'Lançar notas de anos anteriores',
    component: () => import('./views/tec-ped/lancarNota/LancarNotaAnosanteriores.vue')
  },
  {
    path: '/lancar-nota/segundo_trimestre_ano_anterior',
    meta: { layout: 'default' },
    name: 'lancar_notas_segundo_trimestre_ano_anterior',
    component: () => import('./views/tec-ped/lancarNota/LancarNota2T-anterior.vue')
  },
  {
    path: '/lancar-nota/terceiro_trimestre_ano_anterior',
    meta: { layout: 'default' },
    name: 'lancar_notas_terceiro_trimestre_ano_anterior',
    component: () => import('./views/tec-ped/lancarNota/LancarNota3T-anterior.vue')
  },
  {
    path: '/lancar-nota/finalista_anterior',
    meta: { layout: 'default' },
    name: 'lancar_notas_finalista_ano_anterior',
    component: () => import('./views/tec-ped/lancarNota/NotasFinalista-anterior.vue')
  },
  {
    path: '/lancar-nota/exame_anterior',
    meta: { layout: 'default' },
    name: 'lancar_notas_exame_ano_anterior',
    component: () => import('./views/tec-ped/lancarNota/NotaExame-Admin-anterior.vue')
  },
  {
    path: '/lancar-nota/recurso_anterior',
    meta: { layout: 'default' },
    name: 'lancar_notas_recurso_ano_anterior',
    component: () => import('./views/tec-ped/lancarNota/NotaRecurso-anterior.vue')
   },
   {
    path: '/lancar-nota/exame_especial_anterior',
    meta: { layout: 'default' },
    name: 'Lançamento de nota exame especial anterior',
    component: () => import('./views/tec-ped/lancarNota/NotaExameEspecial-anterior.vue')
   },
   {
    path: '/lancar-nota/exame_especial',
    meta: { layout: 'default' },
    name: 'Lançamento de nota exame especial',
    component: () => import('./views/tec-ped/lancarNota/NotaExameEspecial.vue')
   },

  //=========== FIM ROTAS NO MENU LANÇAMENTO DE NOTAS =================



  {
    path: '/impressao/menu',
    meta: { layout: 'default' },
    name: 'menu_impressao',
    component: () => import('./views/tec-ped/impressao/menu.vue')
  },

  {
    path: '/painelclasses-search',
    meta: { layout: 'default' },
    name: 'painelclasses-search',
    component: () => import('./views/tec-ped/painelclasses-search.vue')
  },

  {
    path: '/painelClasseTurma',
    meta: { layout: 'default' },
    name: 'painel_classe_turma',
    component: () => import('./views/tec-ped/PainelClassTurma.vue')
  },



  {
    path: '/pauta_geral_custom',
    meta: { layout: 'default' },
    name: 'pauta_geral',
    component: () => import('./views/tec-ped/imprimir-pauta-custom_2020.vue')
  },
  {
    path: '/Modelo_disciplina_certificado',
    meta: { layout: 'default' },
    name: 'Modelo_disciplina_certificado',
    component: () => import('./views/tec-ped/modelo_disciplina_certificado.vue')
  },
  {
    path: '/sistema-financeiro',
    meta: { layout: 'default' },
    name: 'EltSys Finanças',
    component: () => import('./views/tec-ped/sistemaFinanceiro.vue')
  },
  {
    path: '/negado',
    meta: { layout: 'default' },
    name: 'Acesso Negado',
    component: () => import('./views/acessoNegado.vue')
  },
  {
    path: '/naoPago',
    meta: { layout: 'default' },
    name: 'Acesso Negado',
    component: () => import('./views/naoPago.vue')
  },
  {
    path: '/Nova_Disciplina',
    meta: { layout: 'default' },
    name: 'Nova_Disciplina',
    component: () => import('./views/tec-ped/Disciplina.vue')
  },
  {
    path: '/mudarTurma',
    meta: { layout: 'default' },
    name: 'mudarTurma',
    component: () => import('./views/tec-ped/mudarTurma')
  },
  {
    path: '/PainelClassMudarTurma',
    meta: { layout: 'default' },
    name: 'PainelClassMudarTurma',
    component: () => import('./views/tec-ped/PainelClassMudarTurma.vue')
  },
  {
    path: '/Turmacrud_MudarTurma',
    meta: { layout: 'default' },
    name: 'Turmacrud_MudarTurma',
    component: () => import('./views/tec-ped/Turmacrud_MudarTurma.vue')
  },
  {
    path: '/emolumentos-activosAll',
    meta: { layout: 'default' },
    name: 'emolumentos-activosAll',
    component: () => import('./views/tec-ped/emolumentos-activosAll.vue')
  },
  {
    path: '/listarpagamentoemolumento',
    meta: { layout: 'default' },
    name: 'listarpagamentoemolumento',
    component: () => import('./views/tec-ped/listarpagamentoemolumento.vue')
  },
  {
    path: '/emolumentos-activos',
    meta: { layout: 'default' },
    name: 'emolumentos-activos',
    component: () => import('./views/tec-ped/emolumentos-activos.vue')
  },
  {
    path: '/cadastrar-emolumentos',
    meta: { layout: 'default' },
    name: 'cadastrar-emolumentos',
    component: () => import('./views/tec-ped/cadastrar-emolumentos.vue')
  },
  {
    path: '/erro-pc-mediaFinal',
    meta: { layout: 'default' },
    name: 'erro-pc-mediaFinal',
    component: () => import('./views/tec-ped/erro-pc-mediaFinal.vue')
  },
  {
    path: '/cadastrar-formapagamento',
    meta: { layout: 'default' },
    name: 'cadastrar-formapagamento',
    component: () => import('./views/tec-ped/cadastrar-formapagamento.vue')
  },
  {
    path: '/cadastrar-banco',
    meta: { layout: 'default' },
    name: 'cadastrar-banco',
    component: () => import('./views/tec-ped/cadastrar-banco.vue')
  },
  {
    path: '/definir-director-turma',
    meta: { layout: 'default' },
    name: 'Definição do director de turma',
    component: () => import('./views/tec-ped/definir-directorTurma.vue')
  },
  {
    path: '/add-pauta-disciplina',
    meta: { layout: 'default' },
    name: 'Definição do director de turma',
    component: () => import('./views/tec-ped/add-pauta-disciplina.vue')
  },
  {
    path: '/quando-honra',
    meta: { layout: 'default' },
    name: 'Definição do director de turma',
    component: () => import('./views/tec-ped/quadroHonra.vue')
  },
  {
    path: '/director-turma-search',
    meta: { layout: 'default' },
    name: 'Definição do director de turma pesquisar',
    component: () => import('./views/tec-ped/director-turma-search.vue')
  },
  {
    path: '/director-turma-turmas',
    meta: { layout: 'default' },
    name: 'Definição do director de turma pesquisar',
    component: () => import('./views/tec-ped/director-turmas-turmas.vue')
  },
  {
    path: '/pagar-emolumentos',
    meta: { layout: 'default' },
    name: 'pagar-emolumentos',
    component: () => import('./views/tec-ped/pagar-emolumentos.vue')
  },
  {
    path: '/definir-quantidade-estudantes',
    meta: { layout: 'default' },
    name: 'definir-quantidade-estudantes',
    component: () => import('./views/tec-ped/definir_quantidade_estudante.vue')
  },
  {
    path: '/',
    name: 'login',
    meta: { layout: 'no-sidebar' },
    component: () => import('./views/tec-ped/Login.vue')
  },
  {
    path: '/recupararSenha',
    name: 'recupararSenha',
    meta: { layout: 'no-sideba' },
    component: () => import('./views/tec-ped/recupararSenha.vue')
  },
  {
    path: '/mais-servicos',
    name: 'mais serviços',
    meta: { layout: 'default' },
    component: () => import('./views/tec-ped/servicos.vue')
  },
  {
    path: '/recupararSenha-entradas',
    name: 'recupararSenha-entradas',
    meta: { layout: 'no-sidebar' },
    component: () => import('./views/tec-ped/recupararSenha-entradas.vue')
  },
  {
    path: '/tempo-bloqueio-certificado',
    name: 'tempo-bloqueio-certificado',
    meta: { layout: 'default' },
    component: () => import('./views/tec-ped/tempo_bloqueio_certificado.vue')
  },
  {
    path: '/uploadFiles',
    name: 'uploadFiles',
    meta: { layout: 'default' },
    component: () => import('./views/tec-ped/uploadFiles.vue')
  },

  {
    path: '/mudar-senha',
    name: 'mudar-senha',
    meta: { layout: 'no-sidebar' },
    component: () => import('./views/tec-ped/mudar-senha.vue')
  },
  {
    path: '/mudar-senha-login',
    meta: { layout: 'no-sideba' },
    name: 'mudar-senha-login',
    component: () => import('./views/tec-ped/mudar-senha-login.vue')
  },

  {
    path: '/transacoes-online',
    meta: { layout: 'default' },
    name: 'transacoes-online',
    component: () => import('./views/tec-ped/transacoes-online.vue')
  },
  {
    path: '/lancar-notas-anos-anteriores',
    meta: { layout: 'default' },
    name: 'lancar-notas-anos-anteriores',
    component: () => import('./views/tec-ped/lancar-notas-anos-anteriores.vue')
  },
  {
    path: '/CAA',
    meta: { layout: 'default' },
    name: 'CAA',
    component: () => import('./views/tec-ped/CAA.vue')
  },
  {
    path: '/lancar-notas-anos-anteriores-ims',
    meta: { layout: 'default' },
    name: 'lancar-notas-anos-anteriores',
    component: () => import('./views/tec-ped/lancar-notas-anos-anteriores-ims.vue')
  },
  {
    path: '/LancarNota1T-Admin',
    meta: { layout: 'default' },
    name: 'LancarNota1T-Admin',
    component: () => import('./views/tec-ped/LancarNota1T-Admin.vue')
  },
  {
    path: '/Nota-votada',
    meta: { layout: 'default' },
    name: 'Nota-votada',
    component: () => import('./views/tec-ped/Nota-votada.vue')
  },
  {
    path: '/estudante/Pesquisa-estudantes-finalistas-por-ano',
    meta: { layout: 'default' },
    name: 'Pesquisa-estudantes-finalistas-por-ano',
    component: () => import('./views/tec-ped/Pesquisa-estudantes-finalistas-por-ano.vue')
  },
  {
    path: '/LancarNota2T-Admin',
    meta: { layout: 'default' },
    name: 'LancarNota2T-Admin',
    component: () => import('./views/tec-ped/LancarNota2T-Admin.vue')
  },
  {
    path: '/LancarNota3T-Admin',
    meta: { layout: 'default' },
    name: 'LancarNota3T-Admin',
    component: () => import('./views/tec-ped/LancarNota3T-Admin.vue')
  },
  {
    path: '/Listagem-preparar-certificado-ceil',
    meta: { layout: 'default' },
    name: 'Listagem-preparar-certificado-ceil',
    component: () => import('./views/tec-ped/Listagem-preparar-certificado-ceil.vue')
  },
  {
    path: '/Listagem-preparar-certificado',
    meta: { layout: 'default' },
    name: 'Listagem-preparar-certificado',
    component: () => import('./views/tec-ped/Listagem-preparar-certificado.vue')
  },
  {
    path: '/Historico-estudante',
    meta: { layout: 'default' },
    name: 'Historico-estudante',
    component: () => import('./views/tec-ped/estudante-historico-academico-func.vue')
  },
  {
    path: '/Quadro-honra-detalhes',
    meta: { layout: 'default' },
    name: 'Historico-estudante',
    component: () => import('./views/tec-ped/quadroHonra-detalhes.vue')
  },
  {
    path: '/verificar-estudante',
    meta: { layout: 'default' },
    name: 'verificar-estudante',
    component: () => import('./views/tec-ped/verificarEstudante.vue')
  },
  {
    path: '/certificado-segunda-via',
    meta: { layout: 'default' },
    name: 'Listagem-preparar-certificado',
    component: () => import('./views/tec-ped/certificado_segunda_via.vue')
  },
  {
    path: '/Listagem-preparar-certificado-admin',
    meta: { layout: 'default' },
    name: 'Listagem-preparar-certificado-admin',
    component: () => import('./views/tec-ped/Listagem-preparar-certificado-admin.vue')
  },
  {
    path: '/preparar-certificado-notas',
    meta: { layout: 'default' },
    name: 'preparar-certificado-notas',
    component: () => import('./views/tec-ped/preparar-certificado-notas.vue')
  },
  {
    path: '/preparar-certificado-notas-PesquisaGeral',
    meta: { layout: 'default' },
    name: 'preparar-certificado-notas-PesquisaGeral',
    component: () => import('./views/tec-ped/preparar-certificado-notas-PesquisaGeral.vue')
  },
  {
    path: '/preparar-certificado-notas-admin',
    meta: { layout: 'default' },
    name: 'preparar-certificado-notas-admin',
    component: () => import('./views/tec-ped/preparar-certificado-notas-admin.vue')
  },
  {
    path: '/image-save',
    meta: { layout: 'default' },
    name: 'image-save',
    component: () => import('./views/tec-ped/image-save.vue')
  },
  {
    path: '/preparar-certificado',
    meta: { layout: 'default' },
    name: 'preparar-certificado',
    component: () => import('./views/tec-ped/preparar-certificado.vue')
  },
  {
    path: '/preparar-certificado-segunda-via',
    meta: { layout: 'default' },
    name: 'preparar-certificado',
    component: () => import('./views/tec-ped/preparar-certificado-segunda-via.vue')
  },
  {
    path: '/preparar-certificado-admin',
    meta: { layout: 'default' },
    name: 'preparar-certificado-admin',
    component: () => import('./views/tec-ped/preparar-certificado-admin.vue')
  },
  {
    path: '/preparar-certificado-ceil',
    meta: { layout: 'default' },
    name: 'preparar-certificado-admin',
    component: () => import('./views/tec-ped/preparar-certificado-ceil.vue')
  },
  {
    path: '/welcome',
    meta: { layout: 'default' },
    name: 'Tela Inicial',
    component: () => import('./views/tec-ped/Welcome-menu.vue')
  },
  {
    path: '/welcome-ims',
    meta: { layout: 'default' },
    name: 'welcome',
    component: () => import('./views/tec-ped/Welcome-ims.vue')
  },
  {
    path: '/contacto',
    meta: { layout: 'default' },
    name: 'contacto',
    component: () => import('./views/tec-ped/contacto.vue')
  },
  {
    path: '/welcome-teste',
    meta: { layout: 'default' },
    name: 'welcome-teste',
    component: () => import('./views/tec-ped/Welcome-teste.vue')
  },
  {
    path: '/Professor-disciplina-novo',
    meta: { layout: 'default' },
    name: 'Professor-disciplina-novo',
    component: () => import('./views/tec-ped/Professor-disciplina-novo.vue')
  },
  {
    path: '/estudante-pesquisa',
    meta: { layout: 'default' },
    name: 'estudante-pesquisa',
    component: () => import('./views/tec-ped/Estudante-pesquisa.vue')
  },
  {
    path: '/estudantes-finalistas-pesquisa',
    meta: { layout: 'default' },
    name: 'Estudantes-finalistas-geral',
    component: () => import('./views/tec-ped/Estudantes-finalistas-geral.vue')
  },
  {
    path: '/estudante-fora-epoca',
    meta: { layout: 'default' },
    name: 'Estudante-finalistas-geral',
    component: () => import('./views/tec-ped/Estudantes-fora-epoca-kilamba.vue')
  },
  {
    path: '/estudante-historico',
    meta: { layout: 'default' },
    name: 'estudante-historico',
    component: () => import('./views/tec-ped/estudante-historico-academico.vue')
  },
  {
    path: '/visualizacao-instituicao',
    meta: { layout: 'default' },
    name: 'Instituição Registrado',
    component: () => import('./views/tec-ped/visualizacao-instituicao-cadastrada.vue')
  },
  {
    path: '/estudante-habilitar-usuario',
    meta: { layout: 'default' },
    name: 'estudante-habilitar-usuario',
    component: () => import('./views/tec-ped/Estudante-habilitar-usuario.vue')
  },
  {
    path: '/painelclasses',
    meta: { layout: 'default' },
    name: 'wpainelclasses',
    component: () => import('./views/tec-ped/painelclasses.vue')
  },


  {
    path: '/turmacrud',
    meta: { layout: 'default' },
    name: 'turmacrud',
    component: () => import('./views/tec-ped/turma/Turmacrud.vue')
  },
  {
    path: '/turmacrud24',
    meta: { layout: 'default' },
    name: 'turmacrud ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/cartoes_boletins/Turmacrud24')
  },
  {
    path: '/mapacontroloAv24',
    meta: { layout: 'default' },
    name: 'mapacontroloAv ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/outros_docs/mapacontroloAv.vue')
  },
  {
    path: '/mudancas-estudante',
    meta: { layout: 'default' },
    name: 'mudancas-estudante',
    component: () => import('./views/tec-ped/Mudancas-estudante.vue')
  },
  {
    path: '/Eliminar-disciplina-pauta',
    meta: { layout: 'default' },
    name: 'EliminarDisciplinaPauta',
    component: () => import('./views/tec-ped/EliminarDisciplinaPauta.vue')
  },
  {
    path: '/mudar-classe',
    meta: { layout: 'default' },
    name: 'mudar-class',
    component: () => import('./views/tec-ped/valida-certificado.vue')
  },
  {
    path: '/operacoes-estudante',
    meta: { layout: 'default' },
    name: 'operacoes-estudante',
    component: () => import('./views/tec-ped/valida-certificado.vue')
  },
  {
    path: '/operacoes-instituicao',
    meta: { layout: 'default' },
    name: 'operacoes-instituicao',
    component: () => import('./views/tec-ped/operacoes-instituicao.vue')
  },
  {
    path: '/pedido-mudanca-estudante',
    meta: { layout: 'default' },
    name: 'pedido-mudanca-estudante',
    component: () => import('./views/tec-ped/pedidos-mudanca-estudante.vue')
  },
  {
    path: '/Professor-disciplina-search',
    meta: { layout: 'default' },
    name: 'Professor-disciplina-search',
    component: () => import('./views/tec-ped/funcionario/professorTurmas.vue')
  },
  {
    path: '/pedidos-mudancas-admin',
    meta: { layout: 'default' },
    name: 'pedidos-mudancas-admin',
    component: () => import('./views/tec-ped/pedidos-mudancas-admin.vue')
  },
  {
    path: '/cadastrar-coordenador',
    meta: { layout: 'default' },
    name: 'cadastrar-coordenador',
    component: () => import('./views/tec-ped/Coordenador.vue')
  },
  {
    path: '/coordenador-pesquisar',
    meta: { layout: 'default' },
    name: 'coordenador-pesquisar',
    component: () => import('./views/tec-ped/Coordenador-pesquisar.vue')
  },
  {
    path: '/estudantes-foraTurma',
    meta: { layout: 'default' },
    name: 'estudantes-foraTurma',
    component: () => import('./views/tec-ped/Estudantes-foraTurma.vue')
  },

  {
    path: '/transitacao',
    meta: { layout: 'default' },
    name: 'transitacao',
    component: () => import('./views/tec-ped/transitacao.vue')
  },
  {
    path: '/help',
    meta: { layout: 'default' },
    name: 'help',
    component: () => import('./views/tec-ped/help.vue')
  },
  {
    path: '/no-available',
    meta: { layout: 'default' },
    name: 'no-available',
    component: () => import('./views/tec-ped/no-available.vue')
  },
  {
    path: '/fase-teste',
    meta: { layout: 'default' },
    name: 'fase-teste',
    component: () => import('./views/tec-ped/fase-teste.vue')
  },
  {
    path: '/painelgerirturmas',
    meta: { layout: 'default' },
    name: 'painelgerirturmas',
    component: () => import('./views/tec-ped/painelgerirturmas.vue')
  },
  {
    path: '/lancar-trimestre-um',
    meta: { layout: 'default' },
    name: 'lancar-trimestre-um',
    component: () => import('./views/tec-ped/lancarNota/LancarNota1T.vue')
  },
  {
    path: '/lancar-trimestre-um-novo-modelo',
    meta: { layout: 'default' },
    name: 'lancar-trimestre-um',
    component: () => import('./views/tec-ped/LancarNota1T-Novo-modelo.vue')
  },
  {
    path: '/lancar-trimestre-dois-novo-modelo',
    meta: { layout: 'default' },
    name: 'lancar-trimestre-um',
    component: () => import('./views/tec-ped/LancarNota2T-Novo-Modelo.vue')
  },
  {
    path: '/lancar-trimestre-tres-novo-modelo',
    meta: { layout: 'default' },
    name: 'lancar-trimestre-um',
    component: () => import('./views/tec-ped/LancarNota3T-Novo-Modelo.vue')
  },
  {
    path: '/avalicacao-comportamento',
    meta: { layout: 'default' },
    name: 'avalicacao-comportamento',
    component: () => import('./views/tec-ped/avalicacao-comportamento.vue')
  },
  {
    path: '/lancar-trimestre-dois',
    meta: { layout: 'default' },
    name: 'lancar-trimestre-dois',
    component: () => import('./views/tec-ped/lancarNota/LancarNota2T.vue')
  },
  {
    path: '/lancar-trimestre-tres',
    meta: { layout: 'default' },
    name: 'lancar-trimestre-tres',
    component: () => import('./views/tec-ped/lancarNota/LancarNota3T.vue')
  },



  {
    path: '/abrir-fechar-anolectivo',
    meta: { layout: 'default' },
    name: 'abrir-fechar-anolectivo',
    component: () => import('./views/tec-ped/abrir-fechar-anolectivo.vue')
  },
  {
    path: '/about',
    meta: { layout: 'default' },
    name: 'about',
    component: () => import('./views/tec-ped/About.vue')
  },
  {
    path: '/InserirDisciplinaPautaFarmaciaPatologia',
    meta: { layout: 'default' },
    name: 'Inserir-disciplina-pautas',
    component: () => import('./views/tec-ped/inserirPautaFarmaciaPatologia.vue')
  },
  {
    path: '/InserirDisciplinaPautaEnfermagem',
    meta: { layout: 'default' },
    name: 'Inserir-disciplina-pautas',
    component: () => import('./views/tec-ped/inserirPautaEnfSaudeColectiva.vue')
  },
  {
    path: '/inserirPautaFarmaciaFarmacologia',
    meta: { layout: 'default' },
    name: 'Inserir-disciplina-pautas',
    component: () => import('./views/tec-ped/inserirPautaFarmaciaFarmacologia.vue')
  },

  {
    path: '/senhas-painel-admin',
    meta: { layout: 'default' },
    name: 'senhas-painel-admin',
    component: () => import('./views/tec-ped/senhas-painel-admin.vue')
  },
  {
    path: '/estudante',
    meta: { layout: 'default' },
    name: 'estudante',
    component: () => import('./views/tec-ped/Estudante.vue')
  },
  {
    path: '/estudantes',
    meta: { layout: 'default' },
    name: 'estudantes',
    component: () => import('./views/tec-ped/Estudante-kilamba.vue')
  },
  {
    path: '/cadeira',
    meta: { layout: 'default' },
    name: 'cadeira',
    component: () => import('./views/tec-ped/listarCadeiras.vue')
  },
  {
    path: '/relatorio-cadeira',
    meta: { layout: 'default' },
    name: 'relatorio-cadeira',
    component: () => import('./views/tec-ped/relatorio-cadeira.vue')
  },
  {
    path: '/listagem-relatorio-cadeira',
    meta: { layout: 'default' },
    name: 'listagem-relatorio-cadeira',
    component: () => import('./views/tec-ped/listagem-relatorio-cadeira.vue')
  },
  {
    path: '/listarCadeira',
    meta: { layout: 'default' },
    name: 'listarCadeira',
    component: () => import('./views/tec-ped/listarCadeiras.vue')
  },
  {
    path: '/notasCadeira',
    meta: { layout: 'default' },
    name: 'notasCadeira',
    component: () => import('./views/tec-ped/notasCadeira')
  },
  {
    path: '/inscricao-cadeira',
    meta: { layout: 'default' },
    name: 'inscricao-cadeira',
    component: () => import('./views/tec-ped/inscricaoCadeiraAtraso')
  },
  {
    path: '/perfil',
    meta: { layout: 'default' },
    name: 'perfil',
    component: () => import('./views/tec-ped/perfil')
  },
  {
    path: '/Boletim-Turma',
    meta: { layout: 'default' },
    name: 'boletim-turma',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/cartoes_boletins/boletimTurma_24.vue')
  },
  {
    path: '/ListaAlunos',
    meta: { layout: 'default' },
    name: 'ListaAlunos',
    component: () => import('./views/tec-ped/ListarAlunosTurma')
  },
  {
    path: '/ListaAlunos24',
    meta: { layout: 'default' },
    name: 'ListaAlunos ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/outros_docs/ListarAlunosTurma24')
  },
  {
    path: '/Mudar_curso',
    meta: { layout: 'default' },
    name: 'Mudar_curso',
    component: () => import('./views/tec-ped/MudarCurso')
  },
  {
    path: '/Mudar_instituicao',
    meta: { layout: 'default' },
    name: 'Mudar_Innstituicao',
    component: () => import('./views/tec-ped/MudarInstituicao')
  },
  {
    path: '/Mudar_instituicao_adm',
    meta: { layout: 'default' },
    name: 'Mudar_Innstituicao',
    component: () => import('./views/tec-ped/MudarInstituicao-adm')
  },
  {
    path: '/estudante-teste',
    meta: { layout: 'default' },
    name: 'Mudar_Innstituicao',
    component: () => import('./views/tec-ped/novoMenu')
  },
  {
    path: '/Boletim',
    meta: { layout: 'default' },
    name: 'boletim',
    component: () => import('./views/tec-ped/boletim')
  },
  {
    path: '/Novo-Boletim',
    meta: { layout: 'default' },
    name: 'boletim',
    component: () => import('./views/tec-ped/boletim-novo-Modelo')
  },
  /** ************ */
  {
    path: '/Boletim24',
    meta: { layout: 'default' },
    name: 'boletim ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/boletins/boletim24')
  },
  {
    path: '/Novo-Boletim24',
    meta: { layout: 'default' },
    name: 'novo boletim ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/boletins/boletim-novo-Modelo24')
  },
  /** ******* */
  {
    path: '/sucesso-solicitacao-instituicao',
    meta: { layout: 'default' },
    name: 'boletim',
    component: () => import('./views/tec-ped/sucesso-solicitacao-instituicao')

  },
  {
    path: '/enquadramento',
    meta: { layout: 'default' },
    name: 'tabela',
    component: () => import('./views/tec-ped/enquadramento')
  },
  {
    path: '/solicitacoes-acesso-instituicao',
    meta: { layout: 'default' },
    name: 'tabela',
    component: () => import('./views/tec-ped/solicitacoesAcessoInstituicao')
  },

  {
    path: '/MudarInstituicao',
    meta: { layout: 'default' },
    name: 'MudarInstituicao',
    component: () => import('./views/tec-ped/MudarInstituicao')
  },
  {
    path: '/SolicitarTransferencia',
    meta: { layout: 'default' },
    name: 'SolicitarTranferencia',
    component: () => import('./views/tec-ped/SolicitarTransferencia')
  },
  {
    path: '/ListarTransferido',
    meta: { layout: 'default' },
    name: 'ListarTransferido',
    component: () => import('./views/tec-ped/ListarTransferido')
  },
  {
    path: '/Transferir',
    meta: { layout: 'default' },
    name: 'Transferir',
    component: () => import('./views/tec-ped/Transferir')
  },
  {
    path: '/AlunosPendentes',
    meta: { layout: 'default' },
    name: 'AlunosPendentes',
    component: () => import('./views/tec-ped/AlunosPendentes')
  },
  {
    path: '/MudarEpoca',
    meta: { layout: 'default' },
    name: 'MudarEpoca',
    component: () => import('./views/tec-ped/MudarEpoca')
  },
  {
    path: '/pesquisaLocal',
    meta: { layout: 'default' },
    name: 'pesquisaLocal',
    component: () => import('./views/tec-ped/PesquisaLocal.vue')
  },
  {
    path: '/estudante/pesquisa-outras-instituicoes',
    meta: { layout: 'default' },
    name: 'pesquisaGlobal',
    component: () => import('./views/tec-ped/PesquisaGlobal.vue')
  },
  {
    path: '/pedidos-transferencia',
    meta: { layout: 'default' },
    name: 'pedidos-transferencia',
    component: () => import('./views/tec-ped/estudante/pedidos-transferencia.vue')
  },

  {
    path: '/publicar-sumario',
    meta: { layout: 'default' },
    name: 'publicar-sumario',
    component: () => import('./views/tec-ped/publicar-sumario.vue')
  },
  {
    path: '/menu-pautaTrimestral',
    meta: { layout: 'default' },
    name: 'menu-pautaTrimestral',
    component: () => import('./views/tec-ped/menu-pautaTrimestral.vue')
  },
  {
    path: '/pautaTrimestral',
    meta: { layout: 'default' },
    name: 'pautaTrimestral',
    component: () => import('./views/tec-ped/pautaTrimestral.vue')
  },
  {
    path: '/pautaTrimestral_2020',
    meta: { layout: 'default' },
    name: 'pautaTrimestral_2020',
    component: () => import('./views/tec-ped/pautaTrimestral_2020.vue')
  },
  /** *** */
  {
    path: '/pautaTrimestral24',
    meta: { layout: 'default' },
    name: 'pauta trimestral ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautaTrimestral_24.vue')
  },
  {
    path: '/pautaTrimestral24_2020',
    meta: { layout: 'default' },
    name: 'pauta trimestral ilha 2020',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautaTrimestral_24_2020.vue')
  },
  /** *** */
  {
    path: '/comportamento',
    meta: { layout: 'default' },
    name: 'comportamento',
    component: () => import('./views/tec-ped/comportamento.vue')
  },
  {
    path: '/MensagensRecebidas',
    meta: { layout: 'default' },
    name: 'MensagensRecebidas',
    component: () => import('./views/tec-ped/Mensagens-recebidas copy.vue')
  },
  {
    path: '/estudante-relatorio',
    meta: { layout: 'default' },
    name: 'Relatórios estudante',
    component: () => import('./views/tec-ped/estudante-relatorio.vue')
  },

  {
    path: '/Mensagens-leitura',
    meta: { layout: 'default' },
    name: 'Mensagens-leitura',
    component: () => import('./views/tec-ped/Mensagem-leitura.vue')
  },
  {
    path: '/pauta_geral',
    meta: { layout: 'default' },
    name: 'pauta_geral',
    component: () => import('./views/tec-ped/pautageral_2020.vue')
  },
  {
    path: '/pauta_geral24_2020',
    meta: { layout: 'default' },
    name: 'pauta geral ilha desde 2020',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautageral_24_2020.vue')
  },
  {
    path: '/pauta-anual',
    meta: { layout: 'default' },
    name: 'pauta_geral',
    component: () => import('./views/tec-ped/imprimir-pauta_2020-anual.vue')
  },
  {
    path: '/pauta-anual24',
    meta: { layout: 'default' },
    name: 'pauta anual ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautaanual24_2020.vue')
  },
  {
    path: '/pauta_geral_kilamba',
    meta: { layout: 'default' },
    name: 'pauta_geral',
    component: () => import('./views/tec-ped/imprimir-pauta_2020_kilamba.vue')
  },
  {
    path: '/menu-pauta',
    meta: { layout: 'default' },
    name: 'menu-pauta',
    component: () => import('./views/tec-ped/menu-pauta')
  },
  {
    path: '/menu-pauta-anual',
    meta: { layout: 'default' },
    name: 'menu-pauta',
    component: () => import('./views/tec-ped/menu-pauta-anual')
  },
  {
    path: '/imprimir-pauta',
    meta: { layout: 'default' },
    name: 'imprimir-certificado',
    component: () => import('./views/tec-ped/imprimir-pauta.vue')
  },

  {
    path: '/pautageral_24',
    meta: { layout: 'default' },
    name: 'pauta geral ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautageral_24.vue')
  },


  {
    path: '/ConfirmarInstituicao',
    meta: { layout: 'default' },
    name: 'ConfirmarInstituicao',
    component: () => import('./views/tec-ped/ConfirmarInstituicao.vue')
  },

  {
    path: '/CadastrarInstituicao',
    meta: { layout: 'default' },
    name: 'CadastrarInstituicao',
    component: () => import('./views/tec-ped/CadastrarInstituicao.vue')
  },
  {
    path: '/NotaFinalista',
    meta: { layout: 'default' },
    name: 'NotaFinalista',
    component: () => import('./views/tec-ped/lancarNota/NotasFinalista.vue')
  },
  {
    path: '/NotaFinalista-Admin',
    meta: { layout: 'default' },
    name: 'NotaFinalistaAdmin',
    component: () => import('./views/tec-ped/NotasFinalista-Admin.vue')
  },
  {
    path: '/NotaRecurso',
    meta: { layout: 'default' },
    name: 'NotaRecurso',
    component: () => import('./views/tec-ped/lancarNota/NotaRecurso.vue')
  },
  {
    path: '/NotaExame-Admin',
    meta: { layout: 'default' },
    name: 'NotaExameAdmin',
    component: () => import('./views/tec-ped/lancarNota/NotaExame-Admin.vue')
  },
  {
    path: '/estudante/lixeira',
    meta: { layout: 'default' },
    name: 'lixeira',
    component: () => import('./views/tec-ped/Estudante-lixeira.vue')
  },

  {
    path: '/controlo-actividades',
    meta: { layout: 'default' },
    name: 'controlo-actividades',
    component: () => import('./views/tec-ped/controlo_actividades.vue')
  },
  {
    path: '/linechart',
    meta: { layout: 'default' },
    name: 'linechart',
    component: () => import('./views/tec-ped/analitics-view/LineChart.vue')
  },
  {
    path: '/barchart',
    meta: { layout: 'default' },
    name: 'barchart',
    component: () => import('./views/tec-ped/analitics-view/BarChart.vue')
  },
  {
    path: '/radar',
    meta: { layout: 'default' },
    name: 'radar',
    component: () => import('./views/tec-ped/analitics-view/RadarChart.vue')
  },
  {
    path: '/area',
    meta: { layout: 'default' },
    name: 'area',
    component: () => import('./views/tec-ped/analitics-view/AreaChart.vue')
  },
  {
    path: '/pie',
    meta: { layout: 'default' },
    name: 'pie',
    component: () => import('./views/tec-ped/analitics-view/PieChart.vue')
  },
  {
    path: '/minhas-turmas',
    meta: { layout: 'default' },
    name: 'minhas-turmas',
    component: () => import('./views/tec-ped/minhas-turmas.vue')
  },

  {
    path: '/denied',
    meta: { layout: 'default' },
    name: 'denied',
    component: () => import('./views/denied.vue')
  },
  {
    path: '/no-internet',
    meta: { layout: 'default' },
    name: ' no-internet',
    component: () => import('./views/no-internet.vue')
  },
  {
    path: '/operacoes-disciplina',
    meta: { layout: 'default' },
    name: 'Operações envolvendo as disciplinas',
    component: () => import('./views/tec-ped/disciplinas-operacoes.vue')
  },
  {
    path: '/licenca-vencida',
    meta: { layout: 'default' },
    name: 'licenca-vencida',
    component: () => import('./views/licenca-vencida.vue')
  },
  {
    path: '/sumarios-publicados',
    meta: { layout: 'default' },
    name: 'sumarios-publicados',
    component: () => import('./views/tec-ped/sumarios-publicados.vue')
  },
  {
    path: '/disciplinas-do-aluno',
    meta: { layout: 'default' },
    name: 'disciplinas-do-aluno',
    component: () => import('./views/tec-ped/disciplinas-do-aluno.vue')
  },
  {
    path: '/aulas',
    meta: { layout: 'default' },
    name: 'aulas',
    component: () => import('./views/tec-ped/aulas.vue')
  },
  {
    path: '/estudante/estudante-pesquisa-geral-ims',
    meta: { layout: 'default' },
    name: 'pesquisa-geral',
    component: () => import('./views/tec-ped/Estudante-pesquisa-geral-ims.vue')
  },
  {
    path: '/assistir-aula',
    meta: { layout: 'default' },
    name: 'assistir-aula',
    component: () => import('./views/tec-ped/assistir-aula.vue')
  },
  {
    path: '/declaracoes',
    meta: { layout: 'default' },
    name: 'declaracao',
    component: () => import('./views/tec-ped/declaracoes.vue')
  },
  {
    path: '/cadastrar-sumario',
    meta: { layout: 'default' },
    name: 'cadastrar-sumario',
    component: () => import('./views/tec-ped/cadastrar-sumario.vue')
  },
  {
    path: '/aluno-curso',
    meta: { layout: 'default' },
    name: 'aluno-curso',
    component: () => import('./views/tec-ped/analitics-view/aluno-curso.vue')
  },
  {
    path: '/aluno-anoLectivo',
    meta: { layout: 'default' },
    name: 'aluno-anoLectivo',
    component: () => import('./views/tec-ped/analitics-view/aluno-anoLectivo.vue')
  },
  {
    path: '/aluno-turma',
    meta: { layout: 'default' },
    name: 'aluno-turma',
    component: () => import('./views/tec-ped/analitics-view/aluno-turma.vue')
  },
  {
    path: '/aluno-sexo',
    meta: { layout: 'default' },
    name: 'aluno-sexo',
    component: () => import('./views/tec-ped/analitics-view/aluno-sexo.vue')
  },
  {
    path: '/aluno-classe-estatistica',
    meta: { layout: 'default' },
    name: 'aluno-classe-estatistica',
    component: () => import('./views/tec-ped/analitics-view/aluno-classe-estatistica.vue')
  },

  // Professor
  {
    path: '/professor-curso',
    meta: { layout: 'default' },
    name: 'professor-curso',
    component: () => import('./views/tec-ped/analitics-view/professor-curso.vue')
  },
  {
    path: '/professor-anoLectivo',
    meta: { layout: 'default' },
    name: 'professor-anoLectivo',
    component: () => import('./views/tec-ped/analitics-view/professor-anoLectivo.vue')
  },
  {
    path: '/professor-turma',
    meta: { layout: 'default' },
    name: 'professor-turma',
    component: () => import('./views/tec-ped/analitics-view/professor-turma.vue')
  },

  {
    path: '/professor-classe-estatistica',
    meta: { layout: 'default' },
    name: 'professor-classe-estatistica',
    component: () => import('./views/tec-ped/analitics-view/professor-classe-estatistica.vue')
  },
  {
    path: '/quantidade-turmas',
    meta: { layout: 'default' },
    name: 'quantidade-turmas',
    component: () => import('./views/tec-ped/analitics-view/quantidade-turmas.vue')
  },
  {
    path: '/menu-estatistica',
    meta: { layout: 'default' },
    name: 'menu-estatistica',
    component: () => import('./views/tec-ped/analitics-view/menu-estatistica.vue')
  },
  /** New Routes para  O SLAVE */
  {
    path: '/GerarLicenca',
    meta: { layout: 'default' },
    name: 'renovarLicenca',
    component: () => import('./views/tec-ped/GerarLicenca.vue')
  },
  {
    path: '/RenovarLicenca',
    meta: { layout: 'default' },
    name: 'renovarLicenca',
    component: () => import('./views/tec-ped/renovarLicenca.vue')
  },
  {
    path: '/licencaStatus',
    meta: { layout: 'default' },
    name: 'renovarLicenca',
    component: () => import('./views/tec-ped/licencaStatus.vue')
  },

  {
    path: '/painelclassesExportacao',
    meta: { layout: 'default' },
    name: 'painelclassesExportacao',
    component: () => import('./views/tec-ped/painelclassesExportacao.vue')
  },
  {
    path: '/EstudantesExport_Dados',
    meta: { layout: 'default' },
    name: 'EstudantesExport_Dados',
    component: () => import('./views/tec-ped/EstudantesExport_Dados.vue')
  },
  {
    path: '/EstudantesExport_Dados_cloud',
    meta: { layout: 'default' },
    name: 'EstudantesExport_Dados_cloud',
    component: () => import('./views/tec-ped/EstudantesExport_Dados_cloud.vue')
  },
  {
    path: '/menu-Minipauta',
    meta: { layout: 'default' },
    name: 'menu-Minipauta',
    component: () => import('./views/tec-ped/menu-Minipauta.vue')
  },
  {
    path: '/Turmas-MiniPauta',
    meta: { layout: 'default' },
    name: 'Turmas-MiniPauta',
    component: () => import('./views/tec-ped/minipautaTurma.vue')
  },
  {
    path: '/DisciplinaDaTurma',
    meta: { layout: 'default' },
    name: 'DisciplinaDaTurma',
    component: () => import('./views/tec-ped/disciplinaDaTurma.vue')
  },
  {
    path: '/uploadFotoEstudante',
    meta: { layout: 'default' },
    name: 'uploadFotoEstudante',
    component: () => import('./views/tec-ped/uploadFotoEstudante.vue')
  },
  {
    path: '/testarRota',
    meta: { layout: 'default' },
    name: 'testeRota',
    component: () => import('./views/tec-ped/teste.vue')
  },
  {
    path: '/corrigir-nao-transita',
    meta: { layout: 'default' },
    name: 'corrigir-nao-transita',
    component: () => import('./views/tec-ped/Estudante-finalistas-naoTransita.vue')
  },
  /**
     * Rotas Administração
    */
  {
    path: '/administracao/Mudar_instituicao',
    meta: { layout: 'default' },
    name: 'Mudar_Innstituicao',
    component: () => import('./views/tec-ped/MudarInstituicao')
  },
  {
    path: '/administracao/habilitar-lancamento-anos-anterior',
    meta: { layout: 'default' },
    name: 'Habilitar lançamento anos anterior',
    component: () => import('./views/tec-ped/habilitarLancarNotaAnolectivo.vue')
  },
  {
    path: '/administracao/MudarEpoca',
    meta: { layout: 'default' },
    name: 'MudarEpoca',
    component: () => import('./views/tec-ped/MudarEpoca')
  },
  {
    path: '/administracao/definir-quantidade-estudantes',
    meta: { layout: 'default' },
    name: 'definir-quantidade-estudantes',
    component: () => import('./views/tec-ped/definir_quantidade_estudante.vue')
  },
  {
    path: '/administracao/habilitar-cadastramento-anolectivo',
    meta: { layout: 'default' },
    name: 'Habilitar cadastramento anolectivo',
    component: () => import('./views/tec-ped/habilitarCadastramentoAnolectivo.vue')
  },
  {
    path: '/administracao/habilitar-licenca',
    meta: { layout: 'default' },
    name: 'Habilitar licença',
    component: () => import('./views/tec-ped/habilitarLicenca.vue')
  },
  {
    path: '/administracao/tempo-bloqueio-certificado',
    name: 'tempo-bloqueio-certificado',
    meta: { layout: 'default' },
    component: () => import('./views/tec-ped/tempo_bloqueio_certificado.vue')
  },
  {
    path: '/administracao/pagamentoemolumento',
    name: 'pagamento emolumento',
    meta: { layout: 'default' },
    component: () => import('./views/tec-ped/administracao/pagamentoemolumento.vue')
  },
  /**
     * Rotas para os menus
    */

  {
    path: '/minhasquotas',
    meta: { layout: 'default' },
    name: 'Pagamento de quota',
    component: () => import('./views/tec-ped/administracao/pagamentoquota.vue')
  },
  {
    path: '/administracao/menu',
    meta: { layout: 'default' },
    name: 'administracao',
    component: () => import('./views/tec-ped/administracao/menu.vue')
  },
  {
    path: '/administracao/itensMenu',
    meta: { layout: 'default' },
    name: 'Itens dos Menus',
    component: () => import('./views/tec-ped/administracao/ItensMenu.vue')
  },
  {
    path: '/administracao/funcoes',
    meta: { layout: 'default' },
    name: 'Gerenciamento de Permissões - Adm',
    component: () => import('./views/tec-ped/administracao/funcoesUsuario.vue')
  },
  {
    path: '/administracao/funcoesMenu',
    meta: { layout: 'default' },
    name: 'Gerenciamento de Funções',
    component: () => import('./views/tec-ped/administracao/funcoesUsuarioMenu.vue')
  },
  {
    path: '/administracao/excecoesFuncoes',
    meta: { layout: 'default' },
    name: 'Gerenciamento de Permissões - usuário',
    component: () => import('./views/tec-ped/administracao/excecoesFuncUsuario.vue')
  },
  {
    path: '/administracao/removerdisciplina',
    meta: { layout: 'default' },
    name: 'administracao',
    component: () => import('./views/tec-ped/administracao/removerdisciplinas.vue')
  },
  {
    path: '/administracao/pagamentocota',
    meta: { layout: 'default' },
    name: 'Pagamento de cota',
    component: () => import('./views/tec-ped/administracao/pagamentoquota.vue')
  },

  {
    path: '/professor/menu',
    meta: { layout: 'default' },
    name: 'estudante',
    component: () => import('./views/tec-ped/professor/menu.vue')
  },

  {
    path: '/impressao/pautaTrimestral',
    meta: { layout: 'default' },
    name: 'pautaTrimestral',
    component: () => import('./views/tec-ped/pautaTrimestral.vue')
  },
  {
    path: '/impressao/preparar-certificado-segunda-via',
    meta: { layout: 'default' },
    name: 'preparar-certificado',
    component: () => import('./views/tec-ped/preparar-certificado-segunda-via.vue')
  },
  {
    path: '/impressao/preparar-certificado-notas',
    meta: { layout: 'default' },
    name: 'preparar-certificado-notas',
    component: () => import('./views/tec-ped/preparar-certificado-notas.vue')
  },
  {
    path: '/impressao/certificado-segunda-via',
    meta: { layout: 'default' },
    name: 'Listagem-preparar-certificado',
    component: () => import('./views/tec-ped/certificado_segunda_via.vue')
  },
  {
    path: '/impressao/pauta_geral',
    meta: { layout: 'default' },
    name: 'pauta_geral',
    component: () => import('./views/tec-ped/pautageral_2020.vue')
  },
  {
    path: '/impressao/DisciplinaDaTurma',
    meta: { layout: 'default' },
    name: 'DisciplinaDaTurma',
    component: () => import('./views/tec-ped/disciplinaDaTurma.vue')
  },


  /* ****************************************************************** */
  /** * Rotas para configuração e ajustes */

  {
    path: '/configuracoes/menu',
    meta: { layout: 'default' },
    name: 'configuracoes',
    component: () => import('./views/tec-ped/configuracoes/ItensMenuConfiguracao.vue')
  },


  //* ****************************************************************** */
  /**
     * Rotas para o estudante
     */


    {
      path: '/estudante/estudantes-pesquisa-instituicoes',
      meta: { layout: 'default' },
      name: 'Estudantes-finalistas-geral',
      component: () => import('./views/tec-ped/PesquisaGlobal.vue')
    },
    {
      path: '/estudante/solicitar-certificao-fora-epoca',
      meta: { layout: 'default' },
      name: 'Solicitar estudante fora epoca',
      component: () => import('./views/tec-ped/Estudantes-fora-epoca-cadastro.vue')
    },

    {
      path: '/estudante/minhas-solicitacoes',
      meta: { layout: 'default' },
      name: 'Minhas solicitações de cadastro de anos anteriores',
      component: () => import('./views/tec-ped/minhas-solicitacoes-cadastro-anos-anteriores.vue')
    },
    {
      path: '/estudante/solicitacoes-certificados-anteriores',
      meta: { layout: 'default' },
      name: 'Solicitações certificados anteriores',
      component: () => import('./views/tec-ped/minhas-solicitacoes-cadastro-anos-anteriores.vue')
    },
    {
      path: '/estudante/estudante-historico',
      meta: { layout: 'default' },
      name: 'estudante-historico',
      component: () => import('./views/tec-ped/estudante-historico-academico.vue')
    },
    {
      path: '/estudante/estudantes-fora-Turma',
      meta: { layout: 'default' },
      name: 'estudantes-foraTurma',
      component: () => import('./views/tec-ped/Estudantes-foraTurma.vue')
    },
    {
      path: '/estudante/solicitacoes-transferencia-enviada',
      meta: { layout: 'default' },
      name: 'Solicitações de Transferência Enviadas',
      component: () => import('./views/tec-ped/estudante/solicitacoesEnviadas.vue')
    },
    {
      path: '/estudante/pedidos-transferencia',
      meta: { layout: 'default' },
      name: 'pedidos-transferencia',
      component: () => import('./views/tec-ped/estudante/pedidos-transferencia.vue')
    },
    {
      path: '/estudante/pedidos-mudancas-admin',
      meta: { layout: 'default' },
      name: 'pedidos-mudancas-admin',
      component: () => import('./views/tec-ped/pedidos-mudancas-admin.vue')
    },
    // {
    //   path: '/estudante-relatorio',
    //   meta: { layout: 'default' },
    //   name: 'Relatórios estudante',
    //   component: () => import('./views/tec-ped/estudante-relatorio.vue')
    // },

    {
      path: '/estudante/historico-academico',
      meta: { layout: 'default' },
      name: 'estudante-historico',
      component: () => import('./views/tec-ped/estudante-historico-academico.vue')
    },
    // {
    //   path: '/estudante/historico-academico-componente',
    //   meta: { layout: 'default' },
    //   name: 'estudante-historico',
    //   component: () => import('./views/tec-ped/estudante-historico-academico-componente.vue')
    // },


    {
      path: '/estudante/confirmacao',
      meta: { layout: 'default' },
      name: 'Confirmacao',
      component: () => import('./views/tec-ped/enquadramento.vue')
    },

    {
      path: '/estudante/mudancas-classe-curso',
      meta: { layout: 'default' },
      name: 'Mudanças',
      component: () => import('./views/tec-ped/operacoes-estudante.vue')
    },
    {
      path: '/estudante/mudanca-turma',
      meta: { layout: 'default' },
      name: 'mudarTurma',
      component: () => import('./views/tec-ped/PainelClassMudarTurma')
    },
    {
      path: '/estudante/Turmacrud_MudarTurma',
      meta: { layout: 'default' },
      name: 'Turmacrud_MudarTurma',
      component: () => import('./views/tec-ped/Turmacrud_MudarTurma.vue')
    },
    {
      path: '/estudante/mudarTurma',
      meta: { layout: 'default' },
      name: 'mudarTurma',
      component: () => import('./views/tec-ped/mudarTurma')
    },
    {
      path: '/estudante/painelclasses-search',
      meta: { layout: 'default' },
      name: 'painelclasses-search',
      component: () => import('./views/tec-ped/painelclasses-search.vue')
    },
    {
      path: '/estudante/estudante-pesquisa',
      meta: { layout: 'default' },
      name: 'estudante-pesquisa',
      component: () => import('./views/tec-ped/Estudante-pesquisa.vue')
    },

  {
    path: '/estudante/historico-academico',
    meta: { layout: 'default' },
    name: 'estudante-historico',
    component: () => import('./views/tec-ped/estudante-historico-academico.vue')
  },
  // {
  //   path: '/estudante/historico-academico-componente',
  //   meta: { layout: 'default' },
  //   name: 'estudante-historico',
  //   component: () => import('./views/tec-ped/estudante-historico-academico-componente.vue')
  // },

  {
    path: '/estudante/painelclasses',
    meta: { layout: 'default' },
    name: 'wpainelclasses',
    component: () => import('./views/tec-ped/painelclasses.vue')
  },

  {
    path: '/estudante/confirmacao',
    meta: { layout: 'default' },
    name: 'Confirmacao',
    component: () => import('./views/tec-ped/enquadramento.vue')
  },
  {
    path: '/estudante/mudancas-classe-curso',
    meta: { layout: 'default' },
    name: 'Mudanças',
    component: () => import('./views/tec-ped/operacoes-estudante.vue')
  },
  {
    path: '/estudante/mudanca-turma',
    meta: { layout: 'default' },
    name: 'mudarTurma',
    component: () => import('./views/tec-ped/PainelClassMudarTurma')
  },
  {
    path: '/estudante/Turmacrud_MudarTurma',
    meta: { layout: 'default' },
    name: 'Turmacrud_MudarTurma',
    component: () => import('./views/tec-ped/Turmacrud_MudarTurma.vue')
  },
  {
    path: '/estudante/mudarTurma',
    meta: { layout: 'default' },
    name: 'mudarTurma',
    component: () => import('./views/tec-ped/mudarTurma')
  },
  {
    path: '/estudante/painelclasses-search',
    meta: { layout: 'default' },
    name: 'painelclasses-search',
    component: () => import('./views/tec-ped/painelclasses-search.vue')
  },


  /**
     * Rotas para o lançamento de notas
     */



  {
    path: '/lancar-nota/anos-anteriores',
    meta: { layout: 'default' },
    name: 'Nota de anos anterior ao sistema',
    component: () => import('./views/tec-ped/lancar-notas-anos-anteriores.vue')
  },
  {
    path: '/turma/Novo-Boletim',
    meta: { layout: 'default' },
    name: 'boletim',
    component: () => import('./views/tec-ped/boletim-novo-Modelo')
  },
  {
    path: '/turma/Boletim',
    meta: { layout: 'default' },
    name: 'boletim',
    component: () => import('./views/tec-ped/boletim')
  },
  {
    path: '/turma/ListaAlunos',
    meta: { layout: 'default' },
    name: 'ListaAlunos',
    component: () => import('./views/tec-ped/ListarAlunosTurma')
  },


  /**
     * Rotas Pautas
     */
  {
    path: '/impressao/mini-pautas',
    meta: { layout: 'default' },
    name: 'menu-Minipauta',
    component: () => import('./views/tec-ped/menu-Minipauta.vue')
  },
  {
    path: '/impressao/imprimir-pauta',
    meta: { layout: 'default' },
    name: 'imprimir-certificado',
    component: () => import('./views/tec-ped/imprimir-pauta.vue')
  },
  {
    path: '/impressao/preparar-certificado',
    meta: { layout: 'default' },
    name: 'preparar-certificado',
    component: () => import('./views/tec-ped/preparar-certificado.vue')
  },
  {
    path: '/impressao/pauta-anual24',
    meta: { layout: 'default' },
    name: 'pauta anual ilha',
    component: () => import('./views/tec-ped/menu-pauta-anual')
  },
  {
    path: '/impressao/plano-curricular',
    meta: { layout: 'default' },
    name: 'plano curricular',
    component: () => import('./views/tec-ped/planoCurricularNovo')
  },
  {
    path: '/impressao/solicitacoes',
    meta: { layout: 'default' },
    name: 'Documentos Solicitados',
    component: () => import('./views/tec-ped/impressao/SolicitacoesDocumentos.vue')
  },
  {
    path: '/impressao/disciplinas-notas-pendentes',
    meta: { layout: 'default' },
    name: 'Disciplinas Notas Pendentes',
    component: () => import('@/views/tec-ped/impressao/RelatorioProfessorNotasPendentes.vue')
  },

  {
    path: '/professor-notas-pendentes',
    meta: { layout: 'default' },
    name: 'Meus pendentes',
    component: () => import('./views/tec-ped/professor/professor-notas-pendentes.vue')
  },

  {
    path: '/impressao/mapafrequencia',
    meta: { layout: 'default' },
    name: 'mapa de frequencia',
    component: () => import('./views/tec-ped/impressao/estatistica/mapafrequencia')
  },
  {
    path: '/impressao/mapaaproveitamentoCurso',
    meta: { layout: 'default' },
    name: 'Mapa Estatistico de Aproveitamento por Curso',
    component: () => import('./views/tec-ped/impressao/estatistica/mapaaproveitamentoCurso')
  },
  {
    path: '/impressao/mapaaproveitamentoTrimestre',
    meta: { layout: 'default' },
    name: 'Mapa Estatistico de Aproveitamento por Trimestre',
    component: () => import('./views/tec-ped/impressao/estatistica/mapaaproveitamentotrimestral')
  },
  {
    path: '/impressao/mapaestatistico',
    meta: { layout: 'default' },
    name: 'Mapa Estatistico',
    component: () => import('./views/tec-ped/impressao/estatistica/mapaestatistico')
  },
  {
    path: '/impressao/estatistica_cadastro',
    meta: { layout: 'default' },
    name: 'pauta anual geral',
    component: () => import('./views/tec-ped/estatistica_cadastro')
  },
  {
    path: '/impressao/pauta-trimestral',
    meta: { layout: 'default' },
    name: 'menu-pautaTrimestral',
    component: () => import('./views/tec-ped/menu-pautaTrimestral.vue')
  },
  {
    path: '/impressao/pautaTrimestral_2020',
    meta: { layout: 'default' },
    name: 'pautaTrimestral_2020',
    component: () => import('./views/tec-ped/pautaTrimestral_2020.vue')
  },
  {
    path: '/impressao/pauta-anual',
    meta: { layout: 'default' },
    name: 'menu-pauta impressão',
    component: () => import('./views/tec-ped/menu-pauta-anual')
  },
  {
    path: '/impressao/pauta-final',
    meta: { layout: 'default' },
    name: 'menu-pauta',
    component: () => import('./views/tec-ped/menu-pauta')
  },
  {
    path: '/impressao/Turmas-MiniPauta',
    meta: { layout: 'default' },
    name: 'Turmas-MiniPauta',
    component: () => import('./views/tec-ped/minipautaTurma.vue')
  },
  {
    path: '/impressao/turmas',
    meta: { layout: 'default' },
    name: 'turmacrud ilha',
    component: () => import('./views/tec-ped/turma/Turmacrud.vue')
  },
  {
    path: '/impressao/Listagem-preparar-certificado',
    meta: { layout: 'default' },
    name: 'Listagem-preparar-certificado',
    component: () => import('./views/tec-ped/Listagem-preparar-certificado.vue')
  },


  {
    path: '/professor/menu',
    meta: { layout: 'default' },
    name: 'Professor menu',
    component: () => import('./views/tec-ped/professor/menu.vue')
  },

  {
    path: '/permissoes/menu',
    meta: { layout: 'default' },
    name: 'Permissões menu',
    component: () => import('./views/tec-ped/permissao/menu.vue')
  },


  /**
   * Rotas para o estudante
   */

  {
    path: '/estudante/pedidos-mudancas-admin',
    meta: { layout: 'default' },
    name: 'pedidos-mudancas-admin',
    component: () => import('./views/tec-ped/pedidos-mudancas-admin.vue')
  },
  {
    path: '/estudante-relatorio',
    meta: { layout: 'default' },
    name: 'Relatórios estudante',
    component: () => import('./views/tec-ped/estudante-relatorio.vue')
  },

  {
    path: '/estudante/historico-academico',
    meta: { layout: 'default' },
    name: 'estudante-historico',
    component: () => import('./views/tec-ped/estudante-historico-academico.vue')
  },
  {
    path: '/menu-estudante',
    meta: { layout: 'default' },
    name: 'Tela do estudante',
    component: () => import('./views/tec-ped/estudantes.vue')
  },
  {
    path: '/estudante/historico-academico-componente',
    meta: { layout: 'default' },
    name: 'estudante-historico',
    component: () => import('./views/tec-ped/estudante-historico-academico-componente.vue')
  },

  {
    path: '/estudante/confirmacao',
    meta: { layout: 'default' },
    name: 'Confirmacao',
    component: () => import('./views/tec-ped/enquadramento.vue')
  },
  {
    path: '/estudante/solicitar-transferencia',
    meta: { layout: 'default' },
    name: 'Solicitar Transferência',
    component: () => import('./views/tec-ped/estudante/solicitar-transferencia.vue')
  },
  {
    path: '/estudante/mudancas-classe-curso',
    meta: { layout: 'default' },
    name: 'Mudanças',
    component: () => import('./views/tec-ped/operacoes-estudante.vue') //
  },
  {
    path: '/estudante/valida-certificado',
    meta: { layout: 'default' },
    name: 'Mudanças',
    component: () => import('./views/tec-ped/valida-certificado.vue')
  },
  {
    path: '/estudante/mudanca-turma',
    meta: { layout: 'default' },
    name: 'mudarTurma',
    component: () => import('./views/tec-ped/PainelClassMudarTurma')
  },
  {
    path: '/estudante/Turmacrud_MudarTurma',
    meta: { layout: 'default' },
    name: 'Turmacrud_MudarTurma',
    component: () => import('./views/tec-ped/Turmacrud_MudarTurma.vue')
  },
  {
    path: '/estudante/mudarTurma',
    meta: { layout: 'default' },
    name: 'mudarTurma',
    component: () => import('./views/tec-ped/mudarTurma')
  },
  {
    path: '/estudante/painelclasses-search',
    meta: { layout: 'default' },
    name: 'painelclasses-search',
    component: () => import('./views/tec-ped/painelclasses-search.vue')
  },

  /**
   * Rotas para o lançamento de notas
   */
  {
    path: '/lancar-nota/anos-anteriores',
    meta: { layout: 'default' },
    name: 'Nota de anos anterior ao sistema',
    component: () => import('./views/tec-ped/lancar-notas-anos-anteriores.vue')
  },

  /**
   * Rotas Pautas
   */
  {
    path: '/impressao/mini-pautas',
    meta: { layout: 'default' },
    name: 'menu-Minipauta',
    component: () => import('./views/tec-ped/menu-Minipauta.vue')
  },
  {
    path: '/impressao/mapacontroloAv24',
    meta: { layout: 'default' },
    name: 'mapacontroloAv ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/outros_docs/mapacontroloAv.vue')
  },
  {
    path: '/impressao/minipauta24',
    meta: { layout: 'default' },
    name: 'Mini Pauta ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/minipauta_24.vue')
  },
  {
    path: '/impressao/pauta-anual24',
    meta: { layout: 'default' },
    name: 'pauta anual ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautaanual24_2020.vue')
  },
  {
    path: '/impressao/selecionar-turmas',
    meta: { layout: 'default' },
    name: 'Turmas mapa-avaliacao',
    component: () => import('./views/tec-ped/mapaAvalicaoTurma.vue')
  },
  {
    path: '/impressao/pautaTrimestral24_2020',
    meta: { layout: 'default' },
    name: 'pauta trimestral ilha 2020',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautaTrimestral_24_2020.vue')
  },
  {
    path: '/impressao/pauta-trimestral',
    meta: { layout: 'default' },
    name: 'menu-pautaTrimestral',
    component: () => import('./views/tec-ped/menu-pautaTrimestral.vue')
  },
  {
    path: '/impressao/pauta-anual',
    meta: { layout: 'default' },
    name: 'menu-pauta',
    component: () => import('./views/tec-ped/menu-pauta-anual')
  },
  {
    path: '/impressao/pauta-final',
    meta: { layout: 'default' },
    name: 'menu-pauta',
    component: () => import('./views/tec-ped/menu-pauta')
  },
  {
    path: '/impressao/minipauta24',
    meta: { layout: 'default' },
    name: 'menu-pauta',
    component: () => import('./views/tec-ped/menu-pauta')
  },
  {
    path: '/impressao/turmas',
    meta: { layout: 'default' },
    name: 'turmacrud ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/cartoes_boletins/Turmacrud24')
  },
  {
    path: '/impressao/preparar-certificado',
    meta: { layout: 'default' },
    name: 'Listagem-preparar-certificado',
    component: () => import('./views/tec-ped/Listagem-preparar-certificado.vue')
  },
  {
    path: '/impressao/pauta_geral24_2020',
    meta: { layout: 'default' },
    name: 'pauta geral ilha desde 2020',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/pautas/pautageral_24_2020.vue')
  },
  /**
   * rotas para a gestão
   */
  {
    path: '/gestao/menu',
    meta: { layout: 'default' },
    name: 'Gestão menu',
    component: () => import('./views/tec-ped/gestao/menu.vue')
  },
  {
    path: '/gestao/turmas',
    meta: { layout: 'default' },
    name: 'turmacrud ilha',
    component: () => import('./views/tec-ped/ilha-verdade/relatorios/cartoes_boletins/Turmacrud24')
  },


  {
    path: '/turma/cadastrar',
    meta: { layout: 'default' },
    name: 'Gestão menu',
    component: () => import('./views/tec-ped/turma/cadastrar.vue')
  },
]

const router = new Router({
  routes
})

router.beforeEach(verificandoAutorizacao)

export default router
